<template>
  <b-field label='ニックネーム'>
    <input class="title_input" type="text" placeholder="ニックネーム" v-model="nickname"/>
  </b-field>
</template>

<script>
import * as validation from '@/utils/validation';

export default {
  name: 'NicknameTextField',
  props: {
    value: String,
    isHiddenRequiredSign: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    nickname: function() {
      this.nickname = validation.charaLimit(this.nickname, 12);
    }
  },
  computed: {
    nickname: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/profile-edit.scss';
</style>
